import React, {useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CarReviews from "./../Reviews/CarReviews";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import LpReviews from "../Reviews/LpReviews";
import AddReview from "../Reviews/AddReview";
import Links from "./Links";
import Share from "./Share";
import Typography from "@material-ui/core/Typography/Typography";
import SocialLinks from "./SocialLinks";
import FilterFormDesktop from "../Filter/FilterFormDesktop";
import Support from "../Support/Support";
//import RightColumnAd from "./../Ads/RightColumnAd";

const useStyles = makeStyles((theme) => {
    return {
        nav: {
            width: 300,
            flexShrink: 0,
            wborderLeft: '1px solid rgba(0, 0, 0, 0.12)',
            '@media print' : {
                display: 'none'
            }
        },
        spacer: {
            marginTop: 60,
        },
        itemSpacer: {
            marginTop: 15,
        },
        block: {
            width: 280,
        },
        blockHeader: {
            border: '1px dashed #ccc',
            paddingTop: 5,
            paddingLeft: 20,
            paddingBottom: 5

        },
        blockBody: {
            borderBottom: '1px solid #ccc',
            borderLeft: '1px solid #ccc',
            borderRight: '1px solid #ccc',
        },
        blockFilterBody: {
            border: '1px solid #ccc',
        },
        socialLinks: {
            marginLeft: 15,
            paddingTop: 20,
            height: 50,
        },

    }
});
export default function LeftColumn(props) {
    const classes = useStyles();
    const [submitReview, setSubmitReview] = React.useState(props.submitReview);

    const handleSubmitReview = () => {
        if (!submitReview) {
            setSubmitReview(true);
        }
    };

    const handleClose = () => {
        if (submitReview) {
            setSubmitReview(false);
            window.location.reload();
        }
    };

    const isMobile = props.isMobile;

    if (props.submitReview && !submitReview) {
        setSubmitReview(true);
    }

    const noReviews = props.options && props.options.indexOf('no-reviews') !== -1 || props.noReviews;
    const hasFilter = props.hasFilter;
    return (
        <>
            {props.item ? <>
                <Dialog open={submitReview} onClose={handleClose} aria-labelledby="form-dialog-title">
                    <DialogContent>
                        <AddReview item={props.item} isMobile={isMobile} isPopup={true}/>
                    </DialogContent>
                </Dialog>
                {!isMobile ?
                    <nav className={classes.nav}>
                        {hasFilter ?
                            <FilterFormDesktop item={props.item} filter={props.filter}/>
                             : null }
                        <br/>
                        <div className={classes.block}>
                            <div className={classes.blockHeader}><Typography>Reviews</Typography></div>
                            <div className={classes.blockBody}>
                                <CarReviews item={props.item} setReturnToItemRoute={props.setReturnToItemRoute}
                                            handleSubmitReview={handleSubmitReview} handleReviews={props.handleReviews}/>
                            </div>
                        </div>
                        <br/>
                        {props.links && props.links.length ?
                            <><div className={classes.block}>
                                <div className={classes.blockHeader}><Typography>Recommended</Typography></div>
                                <div className={classes.blockBody}>
                                    <Links links={props.links}/>
                                </div>
                            </div><br/></> : null }

                        <div className={classes.block}>
                            <Support isMobile={isMobile} text={props.text}/>
                        </div>
                    </nav> : null}
                </> : <>
                <Dialog open={submitReview} onClose={handleClose} aria-labelledby="form-dialog-title">
                    <DialogContent>
                        <AddReview lp={window.location.href} isMobile={isMobile} isPopup={true}/>
                    </DialogContent>
                </Dialog>
                {!isMobile ?
                    <nav className={classes.nav}>
                        {hasFilter ?
                            <><FilterFormDesktop item={props.item} filter={props.filter}/>
                                <br/></> : null }
                        {!noReviews ?
                            <><div className={classes.block}>
                                <div className={classes.blockHeader}><Typography>Reviews</Typography></div>
                                <div className={classes.blockBody}>
                                    <LpReviews lp={window.location.href} setReturnToItemRoute={props.setReturnToItemRoute}
                                               handleSubmitReview={handleSubmitReview} handleReviews={props.handleReviews}
                                               displayTitle={null}/>
                                </div>
                            </div>
                            <br/><br/></> : null}
                        {props.links && props.links.length ?
                            <><div className={classes.block}>
                                <div className={classes.blockHeader}><Typography>Recommended</Typography></div>
                            <div className={classes.blockBody}>
                                <Links links={props.links}/>
                            </div>
                        </div><br/><br/></> : null }
                        <div className={classes.block}>
                            <Support isMobile={isMobile} text={props.text} carListPage={true}/>
                        </div>
                    </nav> : null}
            </>}
        </>
    );
}
